angular.module('edxComponents')
  .component('edxLegacyNweaDomainDropdown', {
    templateUrl: '/resources/components/assign-focus/create-nwea-assignment/nwea-domain-dropdown.component.html',
    controller: ['edxLegacyNweaAssignmentService', NweaDomainDropdownController],
    controllerAs: 'vm',
    bindings: {
      onSelect: '&edxOnSelect',
      disabled: '<edxDisabled',
      studentId: '<edxStudentId'
    }
  });

function NweaDomainDropdownController(nweaAssignmentService) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.isDisabled = isDisabled;
  vm.onClick = onClick;

  var DO_NOT_ASSIGN_DOMAIN_OPTION = {
    id: '-1',
    ordinal: -1,
    name: "Don't Assign"
  };

  vm.selected = DO_NOT_ASSIGN_DOMAIN_OPTION;
  vm.loading = true;
  vm.domains = [];

  function $onInit() {
    nweaAssignmentService.loadDomainsForStudent(vm.studentId).then(function (domains) {
      vm.domains = [DO_NOT_ASSIGN_DOMAIN_OPTION].concat(domains);
    }).catch(function(){
      vm.domains = [];
    }).finally(function(){
      vm.loading = false;
    });
  }

  function isDisabled() {
    return !vm.domains || vm.domains.length <= 0 || vm.disabled;
  }

  function onClick(model) {
    if (model && model.id === DO_NOT_ASSIGN_DOMAIN_OPTION.id) {
      vm.onSelect({domain: undefined});
    } else {
      vm.onSelect({domain: model});
    }
  }

}
